// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//comments.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//evidence.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.greenFont {
    color: #00c851 !important;
}
.redFont {
    color:#e50000 !important;
}
.blackFont {
    color:black !important;
}

.resultShowPass {
    background-color: #28a745;
    color:#fff;
    margin-right: 20px;
}

.resultShowFail {
    background-color: #e50000;
    color:#fff;
    margin-right: 20px;
}

.evaluationTree div div ul{
    list-style: none;
    margin: 0px;
    padding: 0px 0px 0px 0.2% !important;
    color: rgb(33, 37, 41);
    font-family: Arial, sans-serif;
    font-size: 14px;
    width: 99%;
    cursor: pointer;
    word-wrap: break-word;
}
.evidenceUploaded {
    display: inline-block;
    background-color: #44aa44;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
}

.evidenceNotUploaded {
    display: inline-block;
    background-color: white;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
}
.evalSubQuestionSeq {
    margin:0.5rem 1rem;
}
.evaluationTree div div ul div ul{
    list-style: none;
    padding-left: 7px !important;
    display: block;
}
.mainQuestionWhyEvaluation,.mainQuestionLibraryEvaluation {
    margin-left:3.7rem;
    margin-top:-6px;
    text-align:justify;
    display:block;
    word-break: normal;
}
.answerCountsTitle {
    color:lightgrey;
    display:inline-block;
    margin-left: 1rem;
    font-size: larger;
}
.answerCountsAns {
    /*   color:rgb(85, 228, 72); */
    color:black;
    font-style: italic;
      display:inline-block;
      margin-left: 0.5rem;
      font-size: small;
      padding-top: 0.18rem;
  }
  .answerCountsTotal {
      font-size: small;
      padding-top: 0.18rem;
  }
  
  .leftAnswerCountsAns {
      color:black;
      font-style: italic;
      font-size: smaller;
      vertical-align: top;
      /* display:inline-block; */
      /* margin-left: 0.5rem; */
  }
  .leftAnswerCountsTotal {
      color: black;
      font-style: italic;
      font-size: smaller;
      vertical-align: top;
  }
  .leftAnswerCountsTotal1 {
    background-color:lightgray;
    font-style: italic;
    font-size: larger;
    vertical-align: top;
}
  .dealerSideNav {
      border-right: 1px solid lightgray;
      width: 24%;
      padding-left: 4px;
  }
  .answerCountsTotal {
      display:inline-block;
      font-style: italic;
  }
.dealerRightPanel {
    width: 72%;
    min-height: 470px!important;
}
.progressLabel {
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 41%;
    color:white;
}

.mainQuestionDetails {
    width:100% !important;
    border: 0.5px solid lightgrey;
}
.evaluationList {
    border:0.5px solid lightgrey;
    padding-top:1rem;
    list-style-type: none;
    width:100%;
    overflow-y: scroll;
    height: 45vh;
}
.subQuestionEvaluation {
    border:1px solid lightgrey;
    margin:0.5rem;
    display:flex;
}
.evaluationAnswers {
    display:inline;
}
.subQuestionEvaluationContent {
    padding-left: 0.25rem;
    padding-bottom:1rem;
    width:100%;
    margin-top:0.5rem;
}
.collapseContainerEval {
    /* margin-left:2rem; */
    margin-right:1rem;
    margin-top:1rem;
    margin-bottom:1rem;
    white-space: pre-wrap;
}
.evalTree div {
    padding:0;
    display:inline-block;
}

#libSideNav .treeBeardContainter ul li div {
    background-color: white !important;
    color:black ;
    font-size: 12px !important;
    font-family: Arial, Helvetica, sans-serif;
    display:block;
    height: 100%;
}
.answerContent {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}
.evaluationAnswerButton {
    display: inline-block;
    width: 13%;
    height: 1.8rem;
    vertical-align: middle;
    text-align: center;
    cursor: pointer; 
    background-color: lightgrey;
    margin: 1rem;
}
.subQuestionDetails {
    width:100%;
}
.evaluationComments-toyota , .evaluationHistory-toyota {
    color: #e50000;
    font-weight: 700;
    display: inline-block;
    /* margin-left: 1rem; */
    margin-right: 0rem;
}
.evaluationComments-lexus , .evaluationHistory-lexus {
    color: #252525;
    font-weight: 700;
    display: inline-block;
    margin-left: 1rem;
    margin-right: 0rem;
}

.comment-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    vertical-align: middle;
    height: 18px;
    width: 22px;
    background-position: center;
    margin: 0 0.3rem;
    display:inline-block;
    
}
.evidence-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    vertical-align: middle;
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    display:inline-block;
    
}

.yesAns {
    background-color:rgb(85, 228, 72);
    cursor:default !important;
}

.ansIncomplete {
    background-color:#FFBF00;
    cursor:default !important;
}
.noAns {
    background-color:#e50000;
    cursor:default !important;
}
.naAns {
    background-color:grey;
    cursor:default !important;
}


/* Progress Bar */

.progress {
    height:1.35rem !important;
}

.progress-bar.bg-danger{
    background-color: #e50000 !important;
}
.progress-bar.bg-success{
    background-color: #28a745 !important;
}

/* Modal CSS */

.uploadModal {
    max-width: 25rem !important;
}

.uploadModal-toyota .modal-dialog, .uploadModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.uploadModal-lexus .modal-dialog, .uploadModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.uploadModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.uploadModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.uploadModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.uploadModal-lexus .css-10nd86i svg {
    color: #252525;
}

.uploadModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.uploadModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-dialog.uploadModal-toyota.modal-dialog-centered,.modal-dialog.uploadModal-lexus.modal-dialog-centered {
    max-width: 1250px !important;
}

.commentHistory tbody{
    overflow-y: scroll;
    max-height: 10rem !important;
    display: block;
    width: 42rem;
}

.commentHistory .table > tbody > tr {
    width: 100%;
    float: left;
} 

.defaultPointer{
    cursor: default; 
}

.isNotApplicable {
    cursor:not-allowed !important;
} 

.addComments .table > tbody > tr > td.react-bs-table-no-data {
    width: 79rem !important;
}



.kaizenPointsModal .css-10nd86i {
    width: 50%;
}

.kaizenPointsModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.kaizenPointsModal-lexus .css-10nd86i svg {
    color: #252525;
}

.kaizenPointsModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.kaizenPointsModal .css-va7pk8 {
    color: #595d60 !important;
}
.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}
.modal-body thead>tr>th{
    width: 5rem;
    float: left;
}
.modal-dialog.kaizenPointsModal.kaizenPointsModal-toyota.modal-dialog-centered .react-bootstrap-table{
    height: 23rem !important;
    overflow-y: auto !important;
    overflow-x: auto !important;
}
.kaizenPointsModal tbody {
    border: solid 1px #a8aaac;
    display: block;
    width: 78rem;
    /* table-layout: fixed !important; */
}
.kaizenPointsModal .table > tbody > tr > td.react-bs-table-no-data {
    width: 79rem !important;
} 


.kaizenPointsModal {
    max-width: 90.375rem !important;
    /* min-width: 1350px;
    width: 100% !important; */
}

.kaizenPointsModal .table > tbody > tr > td {
    word-wrap: break-word;
} 


.kaizenPointsModal-toyota .modal-dialog, .kaizenPointsModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.kaizenPointsModal-lexus .modal-dialog, .kaizenPointsModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.kaizenPointsModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.kaizenPointsModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.kaizenPointsModal .table > tbody > tr {
    width: 100%;
    float: left; 
} 

.addComments tbody{
    min-height: 10rem !important;
}

.kaizenBlink-toyota{
    display: inline-block;
    background-color: #e50000;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
    animation: glowing 1500ms infinite;
}
.kaizenBlink-lexus{
    display: inline-block;
    background-color: #252525;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
    animation: glowing1 1500ms infinite;
}

.kaizenBlinkStop-toyota{
    display: none;
    background-color: #e50000;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
}
.kaizenBlinkStop-lexus{
    display: none;
    background-color: #252525;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
}
  
  @keyframes glowing {
    0% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
    50% { background-color: #FF0000; box-shadow: 0 0 40px #FF0000; }
    100% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
  }
  
  @keyframes glowing1 {
    0% { background-color: rgb(19, 13, 13); box-shadow: 0 0 3px rgb(19, 13, 13); }
    50% { background-color: rgb(43, 31, 31); box-shadow: 0 0 40px rgb(43, 31, 31); }
    100% { background-color: rgb(88, 80, 80); box-shadow: 0 0 3px rgb(88, 80, 80); }
  }

  .kaizenModelMain  .modal.fade.top.show{
    overflow-y: auto !important;
  }
  .queslink:hover {
    color: #e50000;
    cursor: pointer;
  }
  /* .modal-header .close {
    position: relative;
    right: 87px;
} */
@media(min-width:1366px){
    .kaizenPointsModal tbody {
        width: 83rem;
    }
}
@media(min-width:1600px){
    .kaizenPointsModal tbody {
        width: 88rem;
    }
}

.kaizenPointsModal .react-bootstrap-table table {
    table-layout: auto;
}

.parameterTableKaizen .react-bootstrap-table th[data-row-selection] {
    width: 0px;
}

.moveBtn {
    height: 1.8rem;
    padding: 0rem 10px;
}

.parameterTableKaizen .table {
    border-collapse: inherit;
}

.bigThumbFit {
    max-width: 100%;
    object-fit: contain;
}

/*Thumbnail image .css-10nd86i*/
.aspect-ratio-box {
    position: relative;
}

/* Create a pseudo element that uses padding-bottom to take up space */
.aspect-ratio-box::after {
    display: block;
    content: '';
    /* 16:9 aspect ratio */
    padding-bottom: 56.25%;
}

/* Image is positioned absolutely relative to the parent element */
.aspect-ratio-box img {
    /* Image should match parent box size */
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

#container1 {
    display: grid;
    width: 0%;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    grid-gap: 10px;
    gap: 10px;
    padding: 10px;
  }
    
  #container1 {
    aspect-ratio: 3 / 2;
  }
  
  .div1 {
    aspect-ratio: 3 / 2;
  }
  .img1 {
    width: 100%;
    object-fit: cover;
    object-position: center;
  }

  .iframe {
    border: 1px solid white;
    width: 200px;
    height: 150px;
    resize: both;
    /* overflow: auto; */
  }
  
  .wrapper {
    /* background-color: lightgrey; */
    height: 100%;
    /* display: flex; */
  }
  
  .image {
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .evidenceFooter {
    max-width: 1200px !important;
  }
  
  .iframeBg {
    width: 100%;
    height: 100%;
  }
  .imageModalHt {
    width: 35rem !important;
    height: auto;
  }

  .noToYesmsg {
    display: none;
  }
      
  .answerContent:hover + .noToYesmsg {
    background-color:#F7D6D0;
    display: block;
    color:rgb(34, 14, 14);
    width: 230px;
    height: 40px;
    padding: 10px;
    border: 1px solid;
    margin-top:11px;
  }

  .evaluationAnswerButtonGrey{
    background-color: #F7D6D0;
    display: inline-block;
    width: 16%;
    height: 1.8rem;
    vertical-align: middle;
    text-align: center;
    cursor: pointer; 
    margin: 1rem;
  }

  
 .disable-pointer-events {
    pointer-events: none;
}

.answers-card-container {
    background-color: #e50000;
    padding: 5px;
    margin-bottom: 0px;
    width: 100%;
    justify-items: center;
}

.answers-card-headers {
    color: #ffff;
    margin-bottom: 0px
}

.answers-card-values{
    font-size:20px;
    font-weight: 700;
    margin-bottom: 0px
}

.searchIcon-toyota{
    color: #e50000 !important;
}

.searchIcon-toyota-default{
    color: #000 !important;
}

.min-passing-score-css {
    /* margin-right: 22%; */
    font-size: 15px
}

/** For 67%  */
@media screen and (max-width: 2037px) and (min-width: 2030px) {
    .min-passing-score-css {
        font-size: 16px;
        /* margin-right: 11.5%; */
    }
}
/** For 75%  */
@media screen and (max-width: 1850px) and (min-width: 1810px) {
    .min-passing-score-css {
        font-size: 16px;
        /* margin-right: 7%; */
    }
}

/** For 80%  */
@media screen and (max-width: 1700px) and (min-width: 1697px) {
    .min-passing-score-css {
        font-size: 16px;
        /* margin-right: 4%; */
    }
}

/** For 100% */
@media screen and (max-width: 1358px) and (min-width: 1300px) {
    .min-passing-score-css {
        font-size: 14px;
        /* margin-right: -4%; */
    }
}

/** For 110% */
@media screen and (max-width: 1235px) and (min-width: 1200px) {
    .min-passing-score-css {
        font-size: 12px;
        /* margin-right: -5%; */
    }
}
/** For 125% */
@media screen and (max-width: 1100px) and (min-width: 1086px) {
    .min-passing-score-css {
        font-size: 15px;
        /* margin-right: -4%; */
    }
}

/** For 150% */
@media screen and (max-width: 1000px) and (min-width: 905px) {
    .min-passing-score-css {
        font-size: 15px;
        /* margin-right: -4%; */
    }
}

.commentHistoryAudit tbody{
    overflow-y: scroll;
    max-height: 10rem !important;
    display: block;
    width: 76rem;
    overflow-x: hidden;
}
.dealerRightPanelKaizen {
    width: 100%;
    min-height: 470px!important;
}`, "",{"version":3,"sources":["webpack://./src/components/evaluation/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,oCAAoC;IACpC,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;IACf,UAAU;IACV,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;MAChB,oBAAoB;MACpB,mBAAmB;MACnB,gBAAgB;MAChB,oBAAoB;EACxB;EACA;MACI,gBAAgB;MAChB,oBAAoB;EACxB;;EAEA;MACI,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,mBAAmB;MACnB,0BAA0B;MAC1B,yBAAyB;EAC7B;EACA;MACI,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,mBAAmB;EACvB;EACA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;EACE;MACI,iCAAiC;MACjC,UAAU;MACV,iBAAiB;EACrB;EACA;MACI,oBAAoB;MACpB,kBAAkB;EACtB;AACF;IACI,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,aAAa;IACb,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,0BAA0B;IAC1B,yCAAyC;IACzC,aAAa;IACb,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yDAA0D;IAC1D,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;;AAExB;AACA;IACI,yDAA0D;IAC1D,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;;AAExB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;;AAGA,iBAAiB;;AAEjB;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;AAEA,cAAc;;AAEd;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;;;AAIA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,+BAA+B;IAC/B;6BACyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IAIlB,kCAAkC;AACvC;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IAIlB,mCAAmC;AACxC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;EAoBE;IACE,KAAK,yBAAyB,EAAE,2BAA2B,EAAE;IAC7D,MAAM,yBAAyB,EAAE,4BAA4B,EAAE;IAC/D,OAAO,yBAAyB,EAAE,2BAA2B,EAAE;EACjE;;EAqBA;IACE,KAAK,iCAAiC,EAAE,mCAAmC,EAAE;IAC7E,MAAM,iCAAiC,EAAE,oCAAoC,EAAE;IAC/E,OAAO,iCAAiC,EAAE,mCAAmC,EAAE;EACjF;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;;;GAGC;AACH;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,wBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;AACtB;;AAEA,sEAAsE;AACtE;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA,kEAAkE;AAClE;IACI,uCAAuC;IACvC,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;;CAGD;IACG,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,yBAAyB;IAC7B;AACJ;AACA,cAAc;AACd;IACI;QACI,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;AACJ;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;AACJ;AACA,cAAc;AACd;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;AACJ;;AAEA,cAAc;AACd;IACI;QACI,eAAe;QACf,uBAAuB;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,2BAA2B;AAC/B","sourcesContent":[".greenFont {\n    color: #00c851 !important;\n}\n.redFont {\n    color:#e50000 !important;\n}\n.blackFont {\n    color:black !important;\n}\n\n.resultShowPass {\n    background-color: #28a745;\n    color:#fff;\n    margin-right: 20px;\n}\n\n.resultShowFail {\n    background-color: #e50000;\n    color:#fff;\n    margin-right: 20px;\n}\n\n.evaluationTree div div ul{\n    list-style: none;\n    margin: 0px;\n    padding: 0px 0px 0px 0.2% !important;\n    color: rgb(33, 37, 41);\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    width: 99%;\n    cursor: pointer;\n    word-wrap: break-word;\n}\n.evidenceUploaded {\n    display: inline-block;\n    background-color: #44aa44;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n}\n\n.evidenceNotUploaded {\n    display: inline-block;\n    background-color: white;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n}\n.evalSubQuestionSeq {\n    margin:0.5rem 1rem;\n}\n.evaluationTree div div ul div ul{\n    list-style: none;\n    padding-left: 7px !important;\n    display: block;\n}\n.mainQuestionWhyEvaluation,.mainQuestionLibraryEvaluation {\n    margin-left:3.7rem;\n    margin-top:-6px;\n    text-align:justify;\n    display:block;\n    word-break: normal;\n}\n.answerCountsTitle {\n    color:lightgrey;\n    display:inline-block;\n    margin-left: 1rem;\n    font-size: larger;\n}\n.answerCountsAns {\n    /*   color:rgb(85, 228, 72); */\n    color:black;\n    font-style: italic;\n      display:inline-block;\n      margin-left: 0.5rem;\n      font-size: small;\n      padding-top: 0.18rem;\n  }\n  .answerCountsTotal {\n      font-size: small;\n      padding-top: 0.18rem;\n  }\n  \n  .leftAnswerCountsAns {\n      color:black;\n      font-style: italic;\n      font-size: smaller;\n      vertical-align: top;\n      /* display:inline-block; */\n      /* margin-left: 0.5rem; */\n  }\n  .leftAnswerCountsTotal {\n      color: black;\n      font-style: italic;\n      font-size: smaller;\n      vertical-align: top;\n  }\n  .leftAnswerCountsTotal1 {\n    background-color:lightgray;\n    font-style: italic;\n    font-size: larger;\n    vertical-align: top;\n}\n  .dealerSideNav {\n      border-right: 1px solid lightgray;\n      width: 24%;\n      padding-left: 4px;\n  }\n  .answerCountsTotal {\n      display:inline-block;\n      font-style: italic;\n  }\n.dealerRightPanel {\n    width: 72%;\n    min-height: 470px!important;\n}\n.progressLabel {\n    z-index: 10;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin-left: 41%;\n    color:white;\n}\n\n.mainQuestionDetails {\n    width:100% !important;\n    border: 0.5px solid lightgrey;\n}\n.evaluationList {\n    border:0.5px solid lightgrey;\n    padding-top:1rem;\n    list-style-type: none;\n    width:100%;\n    overflow-y: scroll;\n    height: 45vh;\n}\n.subQuestionEvaluation {\n    border:1px solid lightgrey;\n    margin:0.5rem;\n    display:flex;\n}\n.evaluationAnswers {\n    display:inline;\n}\n.subQuestionEvaluationContent {\n    padding-left: 0.25rem;\n    padding-bottom:1rem;\n    width:100%;\n    margin-top:0.5rem;\n}\n.collapseContainerEval {\n    /* margin-left:2rem; */\n    margin-right:1rem;\n    margin-top:1rem;\n    margin-bottom:1rem;\n    white-space: pre-wrap;\n}\n.evalTree div {\n    padding:0;\n    display:inline-block;\n}\n\n#libSideNav .treeBeardContainter ul li div {\n    background-color: white !important;\n    color:black ;\n    font-size: 12px !important;\n    font-family: Arial, Helvetica, sans-serif;\n    display:block;\n    height: 100%;\n}\n.answerContent {\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%);\n}\n.evaluationAnswerButton {\n    display: inline-block;\n    width: 13%;\n    height: 1.8rem;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer; \n    background-color: lightgrey;\n    margin: 1rem;\n}\n.subQuestionDetails {\n    width:100%;\n}\n.evaluationComments-toyota , .evaluationHistory-toyota {\n    color: #e50000;\n    font-weight: 700;\n    display: inline-block;\n    /* margin-left: 1rem; */\n    margin-right: 0rem;\n}\n.evaluationComments-lexus , .evaluationHistory-lexus {\n    color: #252525;\n    font-weight: 700;\n    display: inline-block;\n    margin-left: 1rem;\n    margin-right: 0rem;\n}\n\n.comment-icon {\n    background-image: url(\"../../assets/images//comments.png\");\n    background-repeat: no-repeat;\n    vertical-align: middle;\n    height: 18px;\n    width: 22px;\n    background-position: center;\n    margin: 0 0.3rem;\n    display:inline-block;\n    \n}\n.evidence-icon {\n    background-image: url(\"../../assets/images//evidence.png\");\n    background-repeat: no-repeat;\n    vertical-align: middle;\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    display:inline-block;\n    \n}\n\n.yesAns {\n    background-color:rgb(85, 228, 72);\n    cursor:default !important;\n}\n\n.ansIncomplete {\n    background-color:#FFBF00;\n    cursor:default !important;\n}\n.noAns {\n    background-color:#e50000;\n    cursor:default !important;\n}\n.naAns {\n    background-color:grey;\n    cursor:default !important;\n}\n\n\n/* Progress Bar */\n\n.progress {\n    height:1.35rem !important;\n}\n\n.progress-bar.bg-danger{\n    background-color: #e50000 !important;\n}\n.progress-bar.bg-success{\n    background-color: #28a745 !important;\n}\n\n/* Modal CSS */\n\n.uploadModal {\n    max-width: 25rem !important;\n}\n\n.uploadModal-toyota .modal-dialog, .uploadModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.uploadModal-lexus .modal-dialog, .uploadModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.uploadModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.uploadModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.uploadModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.uploadModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.uploadModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.uploadModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-dialog.uploadModal-toyota.modal-dialog-centered,.modal-dialog.uploadModal-lexus.modal-dialog-centered {\n    max-width: 1250px !important;\n}\n\n.commentHistory tbody{\n    overflow-y: scroll;\n    max-height: 10rem !important;\n    display: block;\n    width: 42rem;\n}\n\n.commentHistory .table > tbody > tr {\n    width: 100%;\n    float: left;\n} \n\n.defaultPointer{\n    cursor: default; \n}\n\n.isNotApplicable {\n    cursor:not-allowed !important;\n} \n\n.addComments .table > tbody > tr > td.react-bs-table-no-data {\n    width: 79rem !important;\n}\n\n\n\n.kaizenPointsModal .css-10nd86i {\n    width: 50%;\n}\n\n.kaizenPointsModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.kaizenPointsModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.kaizenPointsModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.kaizenPointsModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n.modal-body thead>tr>th{\n    width: 5rem;\n    float: left;\n}\n.modal-dialog.kaizenPointsModal.kaizenPointsModal-toyota.modal-dialog-centered .react-bootstrap-table{\n    height: 23rem !important;\n    overflow-y: auto !important;\n    overflow-x: auto !important;\n}\n.kaizenPointsModal tbody {\n    border: solid 1px #a8aaac;\n    display: block;\n    width: 78rem;\n    /* table-layout: fixed !important; */\n}\n.kaizenPointsModal .table > tbody > tr > td.react-bs-table-no-data {\n    width: 79rem !important;\n} \n\n\n.kaizenPointsModal {\n    max-width: 90.375rem !important;\n    /* min-width: 1350px;\n    width: 100% !important; */\n}\n\n.kaizenPointsModal .table > tbody > tr > td {\n    word-wrap: break-word;\n} \n\n\n.kaizenPointsModal-toyota .modal-dialog, .kaizenPointsModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.kaizenPointsModal-lexus .modal-dialog, .kaizenPointsModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.kaizenPointsModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.kaizenPointsModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.kaizenPointsModal .table > tbody > tr {\n    width: 100%;\n    float: left; \n} \n\n.addComments tbody{\n    min-height: 10rem !important;\n}\n\n.kaizenBlink-toyota{\n    display: inline-block;\n    background-color: #e50000;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n    -webkit-animation: glowing 1500ms infinite;\n    -moz-animation: glowing 1500ms infinite;\n    -o-animation: glowing 1500ms infinite;\n     animation: glowing 1500ms infinite;\n}\n.kaizenBlink-lexus{\n    display: inline-block;\n    background-color: #252525;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n    -webkit-animation: glowing1 1500ms infinite;\n    -moz-animation: glowing1 1500ms infinite;\n    -o-animation: glowing1 1500ms infinite;\n     animation: glowing1 1500ms infinite;\n}\n\n.kaizenBlinkStop-toyota{\n    display: none;\n    background-color: #e50000;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n}\n.kaizenBlinkStop-lexus{\n    display: none;\n    background-color: #252525;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n}\n\n@-webkit-keyframes glowing {\n    0% { background-color: #B20000; -webkit-box-shadow: 0 0 3px #B20000; }\n    50% { background-color: #FF0000; -webkit-box-shadow: 0 0 40px #FF0000; }\n    100% { background-color: #B20000; -webkit-box-shadow: 0 0 3px #B20000; }\n  }\n  \n  @-moz-keyframes glowing {\n    0% { background-color: #B20000; -moz-box-shadow: 0 0 3px #B20000; }\n    50% { background-color: #FF0000; -moz-box-shadow: 0 0 40px #FF0000; }\n    100% { background-color: #B20000; -moz-box-shadow: 0 0 3px #B20000; }\n  }\n  \n  @-o-keyframes glowing {\n    0% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }\n    50% { background-color: #FF0000; box-shadow: 0 0 40px #FF0000; }\n    100% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }\n  }\n  \n  @keyframes glowing {\n    0% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }\n    50% { background-color: #FF0000; box-shadow: 0 0 40px #FF0000; }\n    100% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }\n  }\n\n\n  @-webkit-keyframes glowing1 {\n    0% { background-color: rgb(19, 13, 13); -webkit-box-shadow: 0 0 3px rgb(19, 13, 13); }\n    50% { background-color: rgb(43, 31, 31); -webkit-box-shadow: 0 0 40px rgb(43, 31, 31); }\n    100% { background-color: rgb(88, 80, 80); -webkit-box-shadow: 0 0 3px rgb(88, 80, 80); }\n  }\n  \n  @-moz-keyframes glowing1 {\n    0% { background-color: rgb(19, 13, 13); -moz-box-shadow: 0 0 3px rgb(19, 13, 13); }\n    50% { background-color: rgb(43, 31, 31); -moz-box-shadow: 0 0 40px rgb(43, 31, 31); }\n    100% { background-color: rgb(88, 80, 80); -moz-box-shadow: 0 0 3px rgb(88, 80, 80); }\n  }\n  \n  @-o-keyframes glowing1 {\n    0% { background-color: rgb(19, 13, 13); box-shadow: 0 0 3px rgb(19, 13, 13); }\n    50% { background-color: rgb(43, 31, 31); box-shadow: 0 0 40px rgb(43, 31, 31); }\n    100% { background-color: rgb(88, 80, 80); box-shadow: 0 0 3px rgb(88, 80, 80); }\n  }\n  \n  @keyframes glowing1 {\n    0% { background-color: rgb(19, 13, 13); box-shadow: 0 0 3px rgb(19, 13, 13); }\n    50% { background-color: rgb(43, 31, 31); box-shadow: 0 0 40px rgb(43, 31, 31); }\n    100% { background-color: rgb(88, 80, 80); box-shadow: 0 0 3px rgb(88, 80, 80); }\n  }\n\n  .kaizenModelMain  .modal.fade.top.show{\n    overflow-y: auto !important;\n  }\n  .queslink:hover {\n    color: #e50000;\n    cursor: pointer;\n  }\n  /* .modal-header .close {\n    position: relative;\n    right: 87px;\n} */\n@media(min-width:1366px){\n    .kaizenPointsModal tbody {\n        width: 83rem;\n    }\n}\n@media(min-width:1600px){\n    .kaizenPointsModal tbody {\n        width: 88rem;\n    }\n}\n\n.kaizenPointsModal .react-bootstrap-table table {\n    table-layout: auto;\n}\n\n.parameterTableKaizen .react-bootstrap-table th[data-row-selection] {\n    width: 0px;\n}\n\n.moveBtn {\n    height: 1.8rem;\n    padding: 0rem 10px;\n}\n\n.parameterTableKaizen .table {\n    border-collapse: unset;\n}\n\n.bigThumbFit {\n    max-width: 100%;\n    object-fit: contain;\n}\n\n/*Thumbnail image .css-10nd86i*/\n.aspect-ratio-box {\n    position: relative;\n}\n\n/* Create a pseudo element that uses padding-bottom to take up space */\n.aspect-ratio-box::after {\n    display: block;\n    content: '';\n    /* 16:9 aspect ratio */\n    padding-bottom: 56.25%;\n}\n\n/* Image is positioned absolutely relative to the parent element */\n.aspect-ratio-box img {\n    /* Image should match parent box size */\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n}\n\n#container1 {\n    display: grid;\n    width: 0%;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 10px;\n    padding: 10px;\n  }\n    \n  #container1 {\n    aspect-ratio: 3 / 2;\n  }\n  \n  .div1 {\n    aspect-ratio: 3 / 2;\n  }\n  .img1 {\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n\n  .iframe {\n    border: 1px solid white;\n    width: 200px;\n    height: 150px;\n    resize: both;\n    /* overflow: auto; */\n  }\n  \n  .wrapper {\n    /* background-color: lightgrey; */\n    height: 100%;\n    /* display: flex; */\n  }\n  \n  .image {\n    margin: 0 auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n  .evidenceFooter {\n    max-width: 1200px !important;\n  }\n  \n  .iframeBg {\n    width: 100%;\n    height: 100%;\n  }\n  .imageModalHt {\n    width: 35rem !important;\n    height: auto;\n  }\n\n  .noToYesmsg {\n    display: none;\n  }\n      \n  .answerContent:hover + .noToYesmsg {\n    background-color:#F7D6D0;\n    display: block;\n    color:rgb(34, 14, 14);\n    width: 230px;\n    height: 40px;\n    padding: 10px;\n    border: 1px solid;\n    margin-top:11px;\n  }\n\n  .evaluationAnswerButtonGrey{\n    background-color: #F7D6D0;\n    display: inline-block;\n    width: 16%;\n    height: 1.8rem;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer; \n    margin: 1rem;\n  }\n\n  \n .disable-pointer-events {\n    pointer-events: none;\n}\n\n.answers-card-container {\n    background-color: #e50000;\n    padding: 5px;\n    margin-bottom: 0px;\n    width: 100%;\n    justify-items: center;\n}\n\n.answers-card-headers {\n    color: #ffff;\n    margin-bottom: 0px\n}\n\n.answers-card-values{\n    font-size:20px;\n    font-weight: 700;\n    margin-bottom: 0px\n}\n\n.searchIcon-toyota{\n    color: #e50000 !important;\n}\n\n.searchIcon-toyota-default{\n    color: #000 !important;\n}\n\n.min-passing-score-css {\n    /* margin-right: 22%; */\n    font-size: 15px\n}\n\n/** For 67%  */\n@media screen and (max-width: 2037px) and (min-width: 2030px) {\n    .min-passing-score-css {\n        font-size: 16px;\n        /* margin-right: 11.5%; */\n    }\n}\n/** For 75%  */\n@media screen and (max-width: 1850px) and (min-width: 1810px) {\n    .min-passing-score-css {\n        font-size: 16px;\n        /* margin-right: 7%; */\n    }\n}\n\n/** For 80%  */\n@media screen and (max-width: 1700px) and (min-width: 1697px) {\n    .min-passing-score-css {\n        font-size: 16px;\n        /* margin-right: 4%; */\n    }\n}\n\n/** For 100% */\n@media screen and (max-width: 1358px) and (min-width: 1300px) {\n    .min-passing-score-css {\n        font-size: 14px;\n        /* margin-right: -4%; */\n    }\n}\n\n/** For 110% */\n@media screen and (max-width: 1235px) and (min-width: 1200px) {\n    .min-passing-score-css {\n        font-size: 12px;\n        /* margin-right: -5%; */\n    }\n}\n/** For 125% */\n@media screen and (max-width: 1100px) and (min-width: 1086px) {\n    .min-passing-score-css {\n        font-size: 15px;\n        /* margin-right: -4%; */\n    }\n}\n\n/** For 150% */\n@media screen and (max-width: 1000px) and (min-width: 905px) {\n    .min-passing-score-css {\n        font-size: 15px;\n        /* margin-right: -4%; */\n    }\n}\n\n.commentHistoryAudit tbody{\n    overflow-y: scroll;\n    max-height: 10rem !important;\n    display: block;\n    width: 76rem;\n    overflow-x: hidden;\n}\n.dealerRightPanelKaizen {\n    width: 100%;\n    min-height: 470px!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
